import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MainContent, MainContentMobile } from '.'
import { StatusHandler } from '../../../components'
import { fetchFeaturedResources, fetchResources as fetcher } from '../../../features/resources/slice'
import { useViewport } from '../../../utils'
import * as pageConfig from "../config";
import { resourcesActions as actions } from "../../../features/resources/slice";

const PageContent = () => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const {data, status, error, data_featured} = useSelector(state => state.resources)

  // request data to FEATURED resources API
  React.useEffect(() => {
    dispatch(fetchFeaturedResources())
    // eslint-disable-next-line
  }, [])

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => dispatch(fetcher())}
    >
      {
        isDesktop ? (
          <MainContent
            data={data}
            pageConfig={pageConfig}
            actions={actions}
            defaultFeaturedItems={data_featured}
          />
        ) : (
          <MainContentMobile
            resources={data}
            pageConfig={pageConfig}
            actions={actions}
          />
        )
      }
    </StatusHandler>
  )
}

export { PageContent }
